import { type ReactElement, useEffect, useRef, useState, useMemo } from 'react';
import uniq from 'lodash/uniq';
import { ScrollSaver, SongList } from 'components';
import { Nullable } from 'types';
import { useUserStore } from 'services/hooks';
import { SongListWrapper, SongsLibraryContainer } from './styled';

const SongsLibrary = (): ReactElement => {
  const scrollableChildRef = useRef<HTMLDivElement>(null);
  const [scrollableElement, setScrollableElement] =
    useState<Nullable<HTMLElement>>();

  const {
    userStore,
    getSongs,
    resetSongs,
    resetNewSongsInLibraryFlag,
    isGetSongsLoading,
    saveScrollPosition,
  } = useUserStore();
  const { ids, page, newSongsInLibrary, songListPosition } =
    userStore.songsLibrary;

  const resetSongList = () => {
    resetSongs();
    getSongs(1);
    resetNewSongsInLibraryFlag();
  };

  useEffect(() => {
    if (page === 0 || newSongsInLibrary) {
      resetSongList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newSongsInLibrary]);

  useEffect(() => {
    if (scrollableChildRef.current) {
      setScrollableElement(scrollableChildRef.current.parentElement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollableChildRef.current]);

  // uniq is a workaround here due to tracks duplication
  // refactoring ticket: STR-3004
  const songIds = useMemo(() => uniq(ids), [ids]);

  return (
    <SongsLibraryContainer ref={scrollableChildRef}>
      <ScrollSaver
        scrollableParent={scrollableElement}
        saveScrollPosition={saveScrollPosition}
        savedScrollPosition={songListPosition}
      >
        <SongListWrapper>
          <SongList
            isGetSongsLoading={isGetSongsLoading}
            onSongsLibraryPage
            songIds={songIds}
          />
        </SongListWrapper>
      </ScrollSaver>
    </SongsLibraryContainer>
  );
};

export default SongsLibrary;
